import ActionTypes from 'app/redux-boneyard/shared-zap/ActionTypes';
import reducer from 'app/redux-boneyard/shared-zap/reducer';
import routes from 'app/shared-zap/routes';

export default {
  actionTypes: ActionTypes,
  reducers: {
    sharedZap: reducer,
  },
  routes,
};
